import { Link, type LinkProps } from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"
import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

type Props = LinkProps & {
  className?: string
  label?: ReactNode
}

// Desktop only: the phone layout navigates with the tab bar and
// `Layout`'s `back` bar.
export function BackLink({ className, label = "Back", ...props }: Props) {
  return (
    <Link
      {...props}
      className={cn(
        "hidden items-center gap-1.5 rounded-full border border-border bg-[var(--surface-input,var(--card))] px-3 py-1.5 text-sm text-muted-foreground transition-colors hover:bg-muted hover:text-foreground desktop:inline-flex",
        className
      )}
    >
      <ArrowLeft className="size-4" />
      {label}
    </Link>
  )
}
